import * as types from "../constants/actionConstants";

const initialState = {
    requiredTokens: undefined
};

function questionnaireRequiredTokensReducer(state = initialState, action) {
    switch (action.type) {
        case types.QUESTIONNAIRE_REQUIRED_TOKENS_GET_SUCCESS:
            return {
                ...state,
                requiredTokens: action.requiredTokens
            };
        case types.QUESTIONNAIRE_REQUIRED_TOKENS_CLEAR:
            return  initialState;
        default:
            return state;
    }
}

export default questionnaireRequiredTokensReducer;
